const mediaItems = [
  { title: '独家探访：顶流明星私宅大曝光', duration: '12:38', views: '128万', img: 'https://readdy.ai/api/search-image?query=An%20artistic%20interior%20design%20scene%20of%20a%20modern%20luxury%20residence%20with%20warm%20lighting%2C%20elegant%20furniture%20and%20art%20pieces%2C%20architectural%20photography%20style%2C%20warm%20neutral%20tones%2C%20clean%20sophisticated%20composition&width=640&height=400&seq=media-01&orientation=landscape' },
  { title: '娱乐圈十年变迁：从选秀到短视频时代', duration: '18:22', views: '96万', img: 'https://readdy.ai/api/search-image?query=A%20nostalgic%20collage%20of%20entertainment%20industry%20evolution%2C%20vintage%20TV%20stage%20transitioning%20to%20modern%20digital%20screens%2C%20warm%20sepia%20to%20vibrant%20colors%2C%20artistic%20timeline%20concept%2C%20editorial%20style&width=640&height=400&seq=media-02&orientation=landscape' },
  { title: '明星红毯造型全解析：谁是最佳穿搭', duration: '08:15', views: '203万', img: 'https://readdy.ai/api/search-image?query=A%20fashionable%20red%20carpet%20event%20scene%20with%20elegant%20gowns%20and%20photography%20flashes%2C%20glamorous%20atmosphere%2C%20warm%20golden%20lighting%2C%20fashion%20editorial%20style%2C%20clean%20luxurious%20composition&width=640&height=400&seq=media-03&orientation=landscape' },
  { title: '幕后故事：一部网剧的诞生全过程', duration: '25:40', views: '67万', img: 'https://readdy.ai/api/search-image?query=A%20film%20production%20behind%20the%20scenes%20with%20camera%20crew%20and%20directors%20monitor%2C%20professional%20filmmaking%20equipment%2C%20warm%20studio%20lighting%2C%20cinematic%20documentary%20style%2C%20clean%20composition&width=640&height=400&seq=media-04&orientation=landscape' },
  { title: '吃瓜圆桌：本周最劲爆的五个瓜', duration: '15:08', views: '312万', img: 'https://readdy.ai/api/search-image?query=A%20modern%20podcast%20studio%20roundtable%20with%20microphones%20and%20headphones%2C%20warm%20cozy%20lighting%2C%20casual%20discussion%20setting%2C%20editorial%20media%20production%20style%2C%20clean%20professional%20composition&width=640&height=400&seq=media-05&orientation=landscape' },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100/80 text-accent-800 text-xs font-medium mb-3">
            <i className="ri-play-circle-line text-sm"></i>
            媒体聚焦
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            媒体聚焦
          </h2>
          <p className="text-foreground-500 text-sm mt-2">精选视频解读，带你看懂娱乐圈</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className={`group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-300/60 transition-all duration-300 cursor-pointer ${
                i === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
              }`}
            >
              <div className={`relative overflow-hidden bg-background-200 ${i === 0 ? 'aspect-[16/9]' : 'aspect-[16/10]'}`}>
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
                  <span className="px-2 py-1 rounded bg-black/60 text-background-50 text-xs font-medium backdrop-blur-sm">
                    {item.duration}
                  </span>
                  <span className="text-background-50 text-xs">
                    <i className="ri-eye-line mr-1"></i>{item.views}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 backdrop-blur-sm">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </span>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}